import { render } from "./PresalePage.vue?vue&type=template&id=423ef6d7&scoped=true"
import script from "./PresalePage.vue?vue&type=script&lang=js"
export * from "./PresalePage.vue?vue&type=script&lang=js"

import "./PresalePage.vue?vue&type=style&index=0&id=423ef6d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423ef6d7"]])

export default __exports__